<div class="container d-flex justify-content-center">
  <div class="w-75 text-center">
    <img src="../../../assets/img/site_en_construction.png" alt="En construction">
    <strong>Vous pouvez me contacter @ jerome.lebot@freelance-bordeaux.fr</strong>
  </div>
</div>
